
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min'
import { wrapperComponent } from '~/builders/component/WrapperComponentBuilder'
import 'vue-slider-component/theme/default.css'
import 'vue-slider-component/dist-css/vue-slider-component.css'

export default wrapperComponent(VueSlider)
